import { render, staticRenderFns } from "./AppSearchResultDapp.vue?vue&type=template&id=1d80f840"
import script from "./AppSearchResultDapp.vue?vue&type=script&lang=js"
export * from "./AppSearchResultDapp.vue?vue&type=script&lang=js"
import style0 from "./AppSearchResultDapp.vue?vue&type=style&index=0&id=1d80f840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports